// The Vue build version to load with the `import` command (runtime-only or
// standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui';
ElementUI.Dialog.props.closeOnClickModal.default = false;
import Vue2OrgTree from 'vue2-org-tree';
import * as filters from './utils/filters';
import 'element-ui/lib/theme-chalk/index.css';
import './assets/css/reset.css';
import './assets/css/common.less';
import './permission' // permission control
import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'
import Cookie from './utils/Cookie'
import  vueSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
import './assets/css/theme-darkblue.less';
import './assets/svgs/index.js';
import './assets/css/tailwind.css';
import SvgIcon from './assets/svgs/index.vue'
import VueCookies from 'vue-cookies'
import 'babel-polyfill'
import './components/index'
require('es6-promise').polyfill()
Vue.use(VueCookies)

Vue.component('SvgIcon', SvgIcon);

Vue.use(vueSwiper)

import WkFile from './components/NewCom/WkFile/Select/main.js'
Vue.use(WkFile);
Vue.prototype.$cookie = Cookie;

import XLSX from 'xlsx'

Vue.prototype.XLSX = XLSX
var rs = Math.random().toString(36).slice(-8);
Vue.prototype.$cookie.set('csrfcookie', rs);
var echarts = require('echarts/lib/echarts')
Vue.use(Viewer);
Viewer.setDefaults({
  Options: {
    'inline': true,
    'button': true,
    navbar: false,
    'title': false,
    'toolbar': true,
    'tooltip': true,
    'movable': false,
    'zoomable': true,
    'rotatable': true,
    'scalable': true,
    'transition': true,
    'fullscreen': true,
    'keyboard': true,
    'url': 'data-source'
  }
});

Object.keys(filters).forEach(item=> {
    Vue.filter(item, filters[item])
})

/** 常用flex组件 */
import {
  Flexbox,
  FlexboxItem
} from '@/components/flexbox'
Vue.component('flexbox', Flexbox)
Vue.component('flexbox-item', FlexboxItem)

Vue.use(ElementUI);
Vue.use(Vue2OrgTree);

import debounce from './directives/clickDebounce'
Vue.use(debounce)

import VueAliplayerV2 from "vue-aliplayer-v2";
Vue.use(VueAliplayerV2);
Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({el: '#app', router, components: {
    App
}, template: '<App/>'})



// WEBPACK FOOTER //
// ./src/main.js